import React, {
  useCallback,
  useEffect,
  useState,
  useMemo,
  useRef,
} from "react";
import MUITable from "../../../common/components/mui-table/mui-table";
import _ from "lodash";
import {
  AlertComponent,
  BreadcrumbComponent,
} from "../../../common/components";
import { Checkbox } from "@mui/material";
import "./campaign-list.scss";
import CampaignFilter from "../campaign-filter/campaign-filter";
import CampaignFilterOptions from "../campaign-filter/campaign-filter-options";
import { filterOptions } from "../campaign-filter/campaign-filter-constant";
import PaginationComponent from "../../../common/components/pagination-component/pagination-component";
import { getCampaigns } from "../../../api/campaign";
import { useLogin } from "../../../common/hooks/useUser";
import { useSetLoading } from "../../../common/hooks/appearance";
import CampaignView from "../campiagn-view/campaign-view";
import { breadcrumbLink } from "./campaign.constant";
// import MassDelete from "./lead-actions/mass-delete";
import { useLocation } from "react-router-dom";
import { actionsOptions } from "../campaign-filter/campaign-filter-constant";
import CampaignActionHandler from "../campaign-actions"; 
import { formatDate } from "../../../utils/utils";
import ViewTask from "../campiagn-view/campaign-view-details/campaign-view-details-view/campaign-view-details-view-activities-info/view-task/view-task";
import { routes } from "../../../constants/routes";

interface SortOption {
  sortDirection: string | null;
  sortBy: string | null;
}
const CampaignList: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);
  const [selectedLeadsFilter, setSelectedLeadsFilters] = useState<number[]>([]);
  const [selectedLeadsFilterOptions, setSelectedLeadsFilterOptions] =
    useState<any[]>(filterOptions);
  const [selectedActions, setSelectedActions] = useState<any>(null);
  const [totalRecords, setTotalRecords] = useState<number>(0); // Set an initial value for testing
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize] = useState<number>(15);
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [searchText, setSearchText] = useState<any>(null);
  const [crumbMappingOption, setCrumbMappingOption] =
    useState<any>(breadcrumbLink);
  const [viewOpen, setViewOpen] = useState<boolean>(false);
  const [selectedCampaignId, setSelectedLeadId] = useState<any>(null);
  const [sortOption, setSortOption] = useState<SortOption>({
    sortDirection: null,
    sortBy: null,
  });
  const [selectedLeadActionScope, setselectedLeadActionScope] =
    useState<string>("");
  const [alertMessage, setAlertMessage] = useState<string | null>(null);
  const [alertType, setAlertType] = useState<
    "error" | "success" | "info" | "warning"
  >("info");
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const options = actionsOptions?.map((item: any) => ({
    ...item,
    isOpen: false,
  }));
  const [menuItems, setMenuItems] = useState<
    { value: string; id: number; isOpen: boolean }[]
  >([...options]);
  const [activeFilters, setActiveFilters] = useState<any>({});
  const isSearchTriggered = useRef(false);
  const [viewTaskvalue, setViewTaskvalue] = useState({
    open: false,
    taskId: null,
  });
  const [viewMeetingvalue, setViewMeetingvalue] = useState({
    open: false,
    meetingId: null,
  });
  const [viewCallValue, setViewCallValue] = useState({
    open: false,
    callId: null,
  });

  const [selectOpen, setSelectOpen] = useState(false);
  const [disableMassActions, setDisableMassActions] = useState<boolean>(true);
  const searchRef = useRef<{ clear: () => void }>(null);
  const handleSearch = _.debounce((text: string) => {
    isSearchTriggered.current = true;
    setCurrentPage(1);
    setSearchText(text);
  }, 500);

  const userDetails = useLogin();
  const campiagnOwner =
    userDetails?.userDetails?.firstName +
    " " +
    userDetails?.userDetails?.lastName;

  const location = useLocation();

  useEffect(() => {
    if (location.state?.message) {
      setAlertMessage(location.state.message);
      setAlertType(location.state.type);
      setAlertOpen(true);
    }
    window.history.replaceState({}, document.title);
  }, [location.state]);

  const fetchCampaigns = async (page = 1, search: string = "",filters: any = {}) => {
    setLoading(true);
    try {
      const offset = (page - 1) * pageSize;
      let params: any = {
        limit: pageSize,
        offset: offset,
      };
      if (sortOption?.sortBy) {
        params = { ...params, ...sortOption };
      }
      if (search) {
        params.searchText = search;
      }
      if (filters?.annualRevenueRange?.min) {
        params.expectedRevenueFrom = Number(filters.annualRevenueRange.min);
      }
      if (filters?.annualRevenueRange?.max) {
        params.expectedRevenueTo = Number(filters.annualRevenueRange.max);
      }
      if (filters?.actualCostRange?.min) {
        params.actualCostFrom = Number(filters.actualCostRange.min);
      }
      if (filters?.actualCostRange?.max) {
        params.actualCostTo = Number(filters.actualCostRange.max);
      }
      if (filters?.budgetedCostRange?.min) {
        params.budgetedCostFrom = Number(filters.budgetedCostRange.min);
      }
      if (filters?.budgetedCostRange?.max) {
        params.budgetedCostTo = Number(filters.budgetedCostRange.max);
      }

      if (filters?.campaignName) {
        params.name = filters.campaignName;
      }
      if (filters?.expectedResponse) {
        params.expectedResponse = filters.expectedResponse;
      }
      if (filters?.type) {
        params.type = filters.type;
      }
      if (filters?.status) {
        params.status = filters.status;
      }
      if (filters?.createdTimeStart && filters.createdTimeEnd) {
        // if (filters.createdTimeStart.isSame(filters.createdTimeEnd)) {
          params.createdTimeFrom = filters.createdTimeStart.startOf("day");
          params.createdTimeTo = filters.createdTimeEnd.endOf("day");
        // } else {
        //   params.createdTimeFrom = filters.createdTimeStart;
        //   params.createdTimeTo = filters.createdTimeEnd;
        // }
      }
      if (filters?.startDateFrom && filters.startDateTo) {
        // if (filters.startDateFrom.isSame(filters.startDateTo)) {
          params.startDateFrom = filters.startDateFrom.startOf("day");
          params.startDateTo = filters.startDateTo.endOf("day");
        // } else {
        //   params.startDateFrom = filters.startDateFrom;
        //   params.startDateTo = filters.startDateTo;
        // }
      }
      if (filters?.endDateFrom && filters.endDateTo) {
        // if (filters.endDateFrom.isSame(filters.endDateTo)) {
          params.endDateFrom = filters.endDateFrom.startOf("day");
          params.endDateTo = filters.endDateTo.endOf("day");
        // } else {
        //   params.endDateFrom = filters.endDateFrom;
        //   params.endDateTo = filters.endDateTo;
        // }
      }
      if (filters?.createdByUserIds?.length > 0) {
        params.createdBy = filters.createdByUserIds.map(Number);
      }
      if (filters?.leadOwnerIds?.length > 0) {
        params.campaignOwners = filters.leadOwnerIds.map(Number);
      }
      const response = await getCampaigns(params, "View Campaigns");
      setData(response.data.data.result);
      setTotalRecords(response.data.data.totalRecords);
      setTimeout(() => setLoading(false), 1000);
    } catch (error: any) {
      setAlertMessage(
        error?.response?.data?.message || "Failed to fetch leads list"
      );
      setAlertType("error");
      setAlertOpen(true);
      setError(error?.response?.data?.message || "Failed to fetch leads list");
      setLoading(false);
    }
  };
  useEffect(() => {
  if (!viewOpen) {
    const pageToUse = isSearchTriggered.current ? 1 : currentPage;
    fetchCampaigns(pageToUse, searchText, activeFilters);
    isSearchTriggered.current = false;
  }
  }, [currentPage, searchText, isOpen, sortOption, viewOpen, activeFilters]);
  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setCurrentPage(value);
  };
  const [selectedLeadsMap, setSelectedLeadsMap] = useState<{
    [page: number]: number[];
  }>({});
  const isAllSelected =
    data.length > 0 &&
    data.every((row) => selectedLeadsMap[currentPage]?.includes(row.id)) &&
    selectedLeadsMap[currentPage]?.length > 0;
  const isIndeterminate =
    selectedLeadsMap[currentPage]?.length > 0 &&
    selectedLeadsMap[currentPage]?.length < data.length;
  const handleSelectAll = () => {
    setSelectedLeadsMap((prev) => {
      const currentPageLeads = data.map((item) => item.id);
      const selectedLeadsOnPage = prev[currentPage] || [];

      if (selectedLeadsOnPage.length > 0) {
        return { ...prev, [currentPage]: [] };
      }
      return { ...prev, [currentPage]: currentPageLeads };
    });
  };

  const handleCheckboxChange = (id: number) => {
    setSelectedLeadsMap((prev) => {
      const prevSelected = prev[currentPage] || [];
      const newSelected = prevSelected.includes(id)
        ? prevSelected.filter((leadId) => leadId !== id)
        : [...prevSelected, id];

      return {
        ...prev,
        [currentPage]: newSelected,
      };
    });
  };

  const headers = [
    {
      key: "select",
      label: (
        <Checkbox
          checked={isAllSelected}
          indeterminate={isIndeterminate}
          onChange={handleSelectAll}
        />
      ),
    },
    { key: "name", label: "Campaign Name", isSortable: true },
    { key: "type", label: "Type", isSortable: true },
    { key: "status", label: "Status", isSortable: true },
    { key: "startDate", label: "Start Date", isSortable: true },
    { key: "endDate", label: "End Date", isSortable: true },
    { key: "campiagnOwner", label: "Campaign Owner", isSortable: true },
  ];

  const mapColumnNameToField = (columnName: string): string => {
    const mapping: Record<string, string> = {
      name: "name",
      type: "type",
      status: "status",
      startDate: "start_date",
      endDate: "end_date",
      campiagnOwner: "owner_id",
    };

    return mapping[columnName] || columnName;
  };
  const handleSort = (column: string, sortType: string) => {
    let sortValues: SortOption = { sortBy: null, sortDirection: null };
    if (sortType !== "Unsort") {
      const mappedField = mapColumnNameToField(column);
      sortValues = { sortBy: mappedField, sortDirection: sortType };
    }
    setCurrentPage(1);
    setSortOption(sortValues);
  };
const handleViewClick = async (leadId: number, leadName: string) => {
    setSelectedLeadId(leadId);
    // setSelectedLeadName(leadName);

    setCrumbMappingOption([
      {
        label: "Campaigns",
        link: routes.CAMPAIGNLIST,
        handleClick: (event: any) => {
          event.preventDefault();
          setViewTaskvalue({ open: false, taskId: null });
          setViewMeetingvalue({ open: false, meetingId: null });
          setViewCallValue({ open: false, callId: null });
          setCrumbMappingOption(breadcrumbLink);
          setViewOpen(false);
          setCurrentPage(1);
        },
      },
      {
        label: "View Campaigns",
        link: routes.CAMPAIGNLIST,
        handleClick: (event: any) => {
          setViewTaskvalue({ open: false, taskId: null });
          setViewMeetingvalue({ open: false, meetingId: null });
          setViewCallValue({ open: false, callId: null });
          event.preventDefault();
          setCrumbMappingOption(breadcrumbLink);
          setViewOpen(false);
          setCurrentPage(1);
        },
      },
      { label: leadName, link: "" },
    ]);

    setViewOpen(true);
  };
  const handleCampaignNameUpdate = (newName: string) => {
    setCrumbMappingOption((prev: any) => {
      const updated = [...prev];
      updated[2] = { ...updated[2], label: newName };
      return updated;
    });
  };

  const formattedData = useMemo(() => {
    if (Array.isArray(data)) {
      return data.map((item) => {
        const fullName = item.name || "-";

        const campaignName = (
          <span
            style={{ cursor: "pointer" }}
            onClick={() => handleViewClick(item.id, fullName)}
          >
            {fullName}
          </span>
        );
        const lOFirstName = item.campaignOwner?.first_name?.trim();
        const lOLastName = item.campaignOwner?.last_name?.trim();
        const campiagnOwnerName =
          lOFirstName && lOLastName
            ? `${lOFirstName} ${lOLastName}`
            : lOFirstName
              ? lOFirstName
              : lOLastName
                ? lOLastName
                : "-";
        return {
          id: item.id,
          name: campaignName,
          type: item.type || "-",
          status: item.status || "-",
          startDate: formatDate(item.start_date) || "-",
          endDate: formatDate(item.end_date) || "-",
          campiagnOwner: campiagnOwnerName,
        };
      });
    }
    return [];
  }, [data, campiagnOwner]);
  const noResultsTxt = useMemo(() => {
    if (loading) {
      return "Loading Campaigns...";
    }
    const hasActiveFilters = Object.keys(activeFilters).length > 0 && Object.values(activeFilters).some(v => v && (Array.isArray(v) ? v.length > 0 : v !== ""));
    if (hasActiveFilters) {
      return "No campaigns found for the selected filter criteria.";
    }
    if (searchText) {
      return "No Campaigns found matching your search criteria.";
    }
    return "No Campaigns found";
  }, [searchText,activeFilters]);

  const handleActionTrigger = (action: string) => {
    setMenuItems((prevItems) =>
      prevItems.map((item) =>
        item.value === action ? { ...item, isOpen: !item?.isOpen } : item
      )
    );
  };


  const handleMassActionMenuClose = () => {
    if (setSelectOpen) setSelectOpen(false)
      setSelectedActions(null);
  }

  
  useEffect(() => {
    if (Object.values(selectedLeadsMap)?.flat(Infinity).length >= 1) {
      setDisableMassActions(false)
    }
    else if (Object.values(selectedLeadsMap)?.flat(Infinity).length === 0) {
      setDisableMassActions(true)
    }
  }, [selectedLeadsMap])

  const resetSearch = () => {
    setSearchText("");
    if (searchRef.current) {
      searchRef.current.clear();
    }
  };
  
  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);

  return (
    <>
      <div className="leadlist-wrapper">
        {/* Breadcrumb Section */}
        <div className="breadcrumb-wrapper">
          <BreadcrumbComponent breadcrumbLink={crumbMappingOption} />
        </div>
        <div style={{ display: !viewOpen ? "block" : "none" }}>
          <div>
            <div>
              <CampaignFilter
                isOpenFilter={isOpenFilter}
                setIsOpenFilter={setIsOpenFilter}
                selectedLeadsFilter={selectedLeadsFilter}
                selectedActions={selectedActions}
                setSelectedActions={setSelectedActions}
                onSearch={handleSearch}
                disabled={disableMassActions}
                selectOpen={selectOpen}
                setSelectOpen={setSelectOpen}
                handleActionTrigger={handleActionTrigger}
                searchRef={searchRef}
                totalCampaigns={data?.length || 0}
              />
            </div>

            {/* Table Section */}
            <div className="lead-list-table-filter">
              <div
                className="lead-list-table"
                style={isOpenFilter ? { width: "80%" } : {}}
              >
                <MUITable
                  headers={headers}
                  data={formattedData.map((item) => ({
                    key: item.id,
                    select: (
                      <Checkbox
                        checked={
                          selectedLeadsMap[currentPage]?.includes(item.id) ||
                          false
                        }
                        onClick={(event) => event.stopPropagation()}
                        onChange={() => handleCheckboxChange(item.id)}
                      />
                    ),
                    name: item.name,
                    type: item.type,
                    status: item.status,
                    startDate: item.startDate,
                    endDate: item.endDate,
                    campiagnOwner: item.campiagnOwner,
                  }))}
                  onSort={handleSort}
                  noResultsTxt={noResultsTxt}
                  onRowClick={(rowData: any) =>
                    handleViewClick(rowData.key, rowData.name)
                  }
                />
              </div>
              {isOpenFilter ? (
                <div className="lead-list-filter">
                  <CampaignFilterOptions
                    isOpenFilter={isOpenFilter}
                    setIsOpenFilter={setIsOpenFilter}
                    selectedLeadsFilter={selectedLeadsFilter}
                    setSelectedLeadsFilters={setSelectedLeadsFilters}
                    selectedLeadsFilterOptions={selectedLeadsFilterOptions}
                    setSelectedLeadsFilterOptions={
                      setSelectedLeadsFilterOptions
                    }
                    onApplyFilters={(filters: any) => {
                      setActiveFilters(filters);
                      setCurrentPage(1);
                    }}
                    activeFilters={activeFilters}

                  />
                </div>
              ) : (
                ""
              )}
            </div>
            {totalRecords && totalRecords > 0 ? (
              <div className="leads-pagination-container">
                <PaginationComponent
                  totalRecords={totalRecords}
                  pageSize={pageSize}
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                />
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
        {!viewOpen ? (
          ""
        ) : (
          <CampaignView
            setLoading={setLoading}
            selectedCampaignId={selectedCampaignId}
            setViewTaskvalue={setViewTaskvalue}
            viewTaskvalue={viewTaskvalue}
            setViewMeetingvalue={setViewMeetingvalue}
            viewMeetingvalue={viewMeetingvalue}
            setCrumbMappingOption={setCrumbMappingOption}
            onCampaignNameUpdate={handleCampaignNameUpdate}
            viewCallValue={viewCallValue}
            setViewCallValue={setViewCallValue}
          />
        )}
      </div>
      <CampaignActionHandler
        selectedCampaigns={selectedLeadsMap}
        setSelectedCampaignsMap={setSelectedLeadsMap}
        selectedActions={selectedActions}
        setSelectedActions={setSelectedActions}
        menuItems={menuItems}
        setMenuItems={setMenuItems}
        fetchCampaigns={() =>
        {
            if (searchText) resetSearch();
            if (currentPage === 1) fetchCampaigns()
            else setCurrentPage(1);
        }}
        selectedLeadActionScope={selectedLeadActionScope}
        setselectedLeadActionScope={setselectedLeadActionScope}
        totalRecords={totalRecords}
        handleMassActionMenuClose={handleMassActionMenuClose}
      />
      <AlertComponent
        message={alertMessage}
        type={alertType ?? "info"}
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
      />
    </>
  );
};

export default CampaignList;
